if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 * Clamps a requested cart quantity to the group cart limit from theme settings.
 * Groups are identified by data-limit-group (e.g. "device", "travelcase") so
 * multiple products sharing a tag (e.g. Pulsetto Lite + Fit) count together.
 */
function updateCartLimitInfo() {
  const seen = new Set();
  let anyLimitReached = false;
  document.querySelectorAll('quantity-selector[data-cart-limit][data-limit-group]').forEach((qs) => {
    const limitGroup = qs.dataset.limitGroup;
    if (seen.has(limitGroup)) return;
    seen.add(limitGroup);
    const cartLimit = parseInt(qs.dataset.cartLimit, 10);
    let totalQty = 0;
    document.querySelectorAll(`quantity-selector[data-limit-group="${limitGroup}"]`).forEach((other) => {
      const inp = other.querySelector('.qty');
      if (inp) totalQty += parseInt(inp.value, 10) || 0;
    });
    if (!isNaN(cartLimit) && totalQty >= cartLimit) anyLimitReached = true;
  });
  document.querySelectorAll('.cart-limit-info').forEach((el) => {
    el.style.display = anyLimitReached ? 'flex' : 'none';
  });
}

function clampToCartLimit(input, requestedValue) {
  const qs = input.closest('quantity-selector');
  if (!qs || !qs.dataset.cartLimit || !qs.dataset.limitGroup) return requestedValue;
  const cartLimit = parseInt(qs.dataset.cartLimit, 10);
  const limitGroup = qs.dataset.limitGroup;
  const requested = parseInt(requestedValue, 10);
  if (isNaN(cartLimit) || isNaN(requested)) return requestedValue;
  let otherQty = 0;
  document.querySelectorAll(`quantity-selector[data-limit-group="${limitGroup}"]`).forEach((otherQs) => {
    if (otherQs === qs) return;
    const inp = otherQs.querySelector('.qty');
    if (inp) otherQty += parseInt(inp.value, 10) || 0;
  });
  return String(Math.min(requested, Math.max(0, cartLimit - otherQty)));
}

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      this.validateQtyRules();
    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // In cart contexts, allow qty 0 — Shopify treats it as line removal.
      const allowZero = this.classList.contains('cart-update');
      const floor = allowZero ? 0 : 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }

      // Cart limit: when increasing, sum total qty across all items in the same limit group
      if (change > 0) {
        const limitGroup = this.dataset.limitGroup;
        const cartLimitAttr = this.dataset.cartLimit;
        if (limitGroup && cartLimitAttr) {
          const cartLimit = parseInt(cartLimitAttr, 10);
          if (!isNaN(cartLimit)) {
            let totalQty = 0;
            document.querySelectorAll(`quantity-selector[data-limit-group="${limitGroup}"]`).forEach((qs) => {
              const inp = qs.querySelector('.qty');
              if (inp) totalQty += parseInt(inp.value, 10) || 0;
            });
            if (totalQty >= cartLimit) return;
          }
        }
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, floor);

      // qty 0 in cart -> defer to the row's .remove button so bundle / bonus /
      // addon child cleanup runs (see Cart._removeWithChildren / CartDrawer._removeWithChildren).
      if (allowZero && quantity === 0) {
        const row = this.closest('.product-cart-item');
        const removeBtn = row && row.querySelector('.remove');
        if (removeBtn) {
          removeBtn.click();
          return;
        }
      }

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();

      // Re-validate all items in the same limit group so their +/message state updates too
      const limitGroup = this.dataset.limitGroup;
      if (limitGroup) {
        document.querySelectorAll(`quantity-selector[data-limit-group="${limitGroup}"]`).forEach((qs) => {
          if (qs !== this) qs.validateQtyRules();
        });
      }
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }

      // Disable + button when group cart limit is reached
      const cartLimitAttr = this.dataset.cartLimit;
      if (cartLimitAttr) {
        const cartLimit = parseInt(cartLimitAttr, 10);
        const limitGroup = this.dataset.limitGroup;
        let totalQty = value;
        if (limitGroup) {
          totalQty = 0;
          document.querySelectorAll(`quantity-selector[data-limit-group="${limitGroup}"]`).forEach((qs) => {
            const inp = qs.querySelector('.qty');
            if (inp) totalQty += parseInt(inp.value, 10) || 0;
          });
        }
        if (!isNaN(cartLimit) && totalQty >= cartLimit) {
          this.add.classList.add('disabled');
        }
      }

      updateCartLimitInfo();
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');

      this._quickAddBound = false;
      this._onQuickAddClick = null;
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }

    disconnectedCallback() {
      if (this.quick_add && this._quickAddBound && this._onQuickAddClick) {
        this.quick_add.removeEventListener('click', this._onQuickAddClick);
      }
      this._quickAddBound = false;
      this._onQuickAddClick = null;
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', function () {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      if (this._quickAddBound) return;
      this._onQuickAddClick = this.quickAdd.bind(this);
      this.quick_add.addEventListener('click', this._onQuickAddClick);
      this._quickAddBound = true;
    }

    async quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      try {
        let items = [{ id: parseInt(this.quick_add.dataset.productId), quantity: 1 }];

        // If device product, add subscription (with dedup check)
        const subVariantId = this.quick_add.dataset.subscriptionVariantId;
        const subSellingPlanId = this.quick_add.dataset.subscriptionSellingPlanId;

        if (subVariantId) {
          try {
            const cartResp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
            if (cartResp.ok) {
              const cart = await cartResp.json();
              const hasSub = cart.items.some(function(item) { return String(item.variant_id) === String(subVariantId); });
              if (!hasSub) {
                let subItem = { id: parseInt(subVariantId), quantity: 1 };
                if (subSellingPlanId) subItem.selling_plan = parseInt(subSellingPlanId);
                items.push(subItem);
              }
            }
          } catch(e) {
            let subItem = { id: parseInt(subVariantId), quantity: 1 };
            if (subSellingPlanId) subItem.selling_plan = parseInt(subSellingPlanId);
            items.push(subItem);
          }
        }

        const response = await fetch(`${theme.routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: items,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
          })
        }).then(function(r) { return r.json(); });

        if (response.status) {
          return;
        }
        this.renderContents(response);

        dispatchCustomEvent('cart:item-added', {
          product: response.hasOwnProperty('items') ? response.items[0] : response
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.quick_add.classList.remove('loading');
        this.quick_add.removeAttribute('aria-disabled');
      }
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          window.cartDrawer.refresh();
          //new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;

      this._addToCartBound = false;
      this._onAddToCartClick = null;
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }

    disconnectedCallback() {
      if (this.button && this._addToCartBound && this._onAddToCartClick) {
        this.button.removeEventListener('click', this._onAddToCartClick);
      }
      this._addToCartBound = false;
      this._onAddToCartClick = null;
    }
    setEventListeners() {
      if (!this.button || this._addToCartBound) return;
      this._onAddToCartClick = this.addToCart.bind(this);
      this.button.addEventListener('click', this._onAddToCartClick);
      this._addToCartBound = true;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    async addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      try {
        let items = [{ id: parseInt(this.id), quantity: 1 }];

        // If device product, add subscription (with dedup check)
        const subVariantId = this.dataset.subscriptionVariantId;
        const subSellingPlanId = this.dataset.subscriptionSellingPlanId;

        if (subVariantId) {
          try {
            const cartResp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
            if (cartResp.ok) {
              const cart = await cartResp.json();
              const hasSub = cart.items.some(function(item) { return String(item.variant_id) === String(subVariantId); });
              if (!hasSub) {
                let subItem = { id: parseInt(subVariantId), quantity: 1 };
                if (subSellingPlanId) subItem.selling_plan = parseInt(subSellingPlanId);
                items.push(subItem);
              }
            }
          } catch(e) {
            let subItem = { id: parseInt(subVariantId), quantity: 1 };
            if (subSellingPlanId) subItem.selling_plan = parseInt(subSellingPlanId);
            items.push(subItem);
          }
        }

        const response = await fetch(`${theme.routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: items,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
          })
        }).then(function(r) { return r.json(); });

        if (response.status) {
          return;
        }

        this.renderContents(response);

        dispatchCustomEvent('cart:item-added', {
          product: response.hasOwnProperty('items') ? response.items[0] : response
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.button.classList.remove('loading');
        this.button.removeAttribute('aria-disabled');
      }
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          window.cartDrawer.refresh();
          //new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }

  document.querySelectorAll("product-card-small").forEach(item => {
    const isUSTagged = item.getAttribute('data-us') === 'true';
    const isCATagged = item.getAttribute('data-ca') === 'true';
    const userCountry = Shopify?.country;

    // Determine if the customer is allowed to purchase based on their country
    const isAllowed =
        (isUSTagged && userCountry === "US") ||
        (isCATagged && userCountry === "CA") ||
        (!isUSTagged && !isCATagged);
    
    console.log(userCountry);

    const addToCartButton = item.querySelector(".product-card-small--add-to-cart-button");

    // Assuming we have a data attribute to check the stock status
    const stockStatus = item.getAttribute('data-stock-status'); // e.g., 'inStock' or 'outOfStock'
    const isInStock = stockStatus === 'inStock';

    if (addToCartButton) {
        if (!isAllowed || !isInStock) {
            addToCartButton.innerHTML = "Sold Out";
            addToCartButton.disabled = true;
            addToCartButton.style.backgroundColor = 'gray';
            addToCartButton.classList.add("btn-unavailable");
        } else {
            // Resetting the button in case it was previously disabled
            addToCartButton.innerHTML = "ADD";
            addToCartButton.disabled = false;
            addToCartButton.style.backgroundColor = '';
            addToCartButton.classList.remove("btn-unavailable");
        }
    }
});

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            if (document.body.classList.contains('open-cc--product')) {
              document.body.classList.remove('open-cc--product');

              setTimeout(() => {
                document.querySelector('#Product-Drawer-Content').innerHTML = '';
              }, 260);
            } else {
              if (panel.classList.contains('cart-drawer')) {
                document.getElementById('cart-drawer-toggle').focus();
              }
              document.body.classList.remove('open-cc');
            }
            panel.classList.remove('active');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      let panel = document.querySelector('.side-panel.active');
      if (panel) {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    if (document.body.classList.contains('open-cc--product')) {
      document.body.classList.remove('open-cc--product');
      setTimeout(() => {
        document.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);
    } else {
      document.body.classList.remove('open-cc');
    }
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');
    window.initCartDrawer = true;
    console.log('[Whoop] CartDrawer initialized');

    if (!this.container) {
      return;
    }
    const button = document.getElementById('cart-drawer-toggle');
    if (!button) return;

    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      this.container.classList.add('active');
      this.container.focus();
      dispatchCustomEvent('cart-drawer:open');
      handleAltProductPrices();
      this.disableUSOnlyProducts();
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    // Terms checkbox
    this.termsCheckbox();
    // Internal guard to avoid re-entrant sync loops
    this._syncingApp = false;
    // When items are added to cart, ensure App Premium stays at qty 1
    document.addEventListener('cart:item-added', () => {
      // slight delay to ensure DOM has updated
      setTimeout(() => {
        this._syncingApp = false;
        this.syncAppDeviceGiftQuantity();
      }, 50);
    });
  }

  disableUSOnlyProducts(){
  document.querySelectorAll("product-card-small").forEach(item => {
    const isUSTagged = item.getAttribute('data-us') === 'true';
    const isCATagged = item.getAttribute('data-ca') === 'true';
    const userCountry = Shopify?.country;

    // Determine if the customer is allowed to purchase based on their country
    const isAllowed =
        (isUSTagged && userCountry === "US") ||
        (isCATagged && userCountry === "CA") ||
        (!isUSTagged && !isCATagged);
    
    console.log(userCountry);

    const addToCartButton = item.querySelector(".product-card-small--add-to-cart-button");

    // Assuming we have a data attribute to check the stock status
    const stockStatus = item.getAttribute('data-stock-status'); // e.g., 'inStock' or 'outOfStock'
    const isInStock = stockStatus === 'inStock';

    if (addToCartButton) {
        if (!isAllowed || !isInStock) {
            addToCartButton.innerHTML = "Sold Out";
            addToCartButton.disabled = true;
            addToCartButton.style.backgroundColor = 'gray';
            addToCartButton.classList.add("btn-unavailable");
        } else {
            // Resetting the button in case it was previously disabled
            addToCartButton.innerHTML = "ADD";
            addToCartButton.disabled = false;
            addToCartButton.style.backgroundColor = '';
            addToCartButton.classList.remove("btn-unavailable");
        }
    }
});

  }
  
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      // qty 0 -> route to .remove for bundle / bonus / addon child cleanup.
      if (Number(event.target.value) === 0) {
        const row = event.target.closest('.product-cart-item');
        const removeBtn = row && row.querySelector('.remove');
        if (removeBtn) {
          removeBtn.click();
          return;
        }
      }
      // Clamp to cart_limit before sending to API (handles manual typed values)
      const clampedQty = clampToCartLimit(event.target, event.target.value);
      if (clampedQty !== event.target.value) event.target.value = clampedQty;
      this.updateQuantity(event.target.dataset.index, clampedQty);
    }
    handleAltProductPrices();
  }
  // Keep App Premium quantity fixed at 1 when any device exists in drawer
  syncAppDeviceGiftQuantity() {
    if (this._syncingApp) {
      return;
    }
    const deviceItems = this.container.querySelectorAll('.product-cart-item[data-pulsetto="device"]');
    let totalDevices = 0;
    deviceItems.forEach((item) => {
      const qtyInput = item.querySelector('.qty');
      if (qtyInput) {
        const val = parseInt(qtyInput.value, 10);
        if (!isNaN(val)) {
          totalDevices += val;
        }
      }
    });

    const appItem = this.container.querySelector('.product-cart-item[data-pulsetto="app"]');
    if (!appItem) {
      return;
    }
    const appQtyInput = appItem.querySelector('.qty');
    if (!appQtyInput) {
      return;
    }
    const currentAppQty = parseInt(appQtyInput.value, 10) || 0;
    const appLine = appQtyInput.dataset.index;

    if (totalDevices > 0 && appLine && currentAppQty !== 1) {
      this._syncingApp = true;
      this.updateQuantity(appLine, '1');
    }
  }
removeProductEvent() {
  console.log('[Whoop] CartDrawer.removeProductEvent()');
  let removes = this.container.querySelectorAll('.remove');
   handleAltProductPrices();

  removes.forEach((remove) => {
    remove.addEventListener('click', (event) => {
      event.preventDefault();
      const btn = event.target.closest('.remove');
      const line = btn.dataset.index;
      const lineKey = btn.dataset.lineKey;
      const parentProductId = btn.dataset.parentProductId;

      // Check if this item has bonus/addon children before doing the expensive _removeWithChildren
      const itemEl = btn.closest('.product-cart-item');
      const hasPulsetto = itemEl && itemEl.dataset.pulsetto;
      const parentGroup = itemEl && (itemEl.closest('.cart-bonus-group') || itemEl.closest('.cart-whoop-group'));
      const bundleGroup = itemEl && itemEl.closest('.cart-bundle-group');
      const hasChildren = parentGroup || (itemEl && itemEl.dataset.bonusConfig);

      if (bundleGroup && hasPulsetto) {
        // Bundle group: remove only this item, then let orphan cleanup handle the rest
        this._pendingOrphanCheck = true;
        this.updateQuantity(line, '0');
      } else if (lineKey && parentProductId && hasChildren) {
        this._removeWithChildren(line, lineKey, parentProductId, !!hasPulsetto);
      } else {
        this.updateQuantity(line, '0');
      }
    });
  });
}

  /**
   * Remove a parent item and all its bonus/addon children.
   * Fetches the cart to find children by _bonus_of / _pdp_addon_of matching the parent product ID,
   * then removes all in sequential /cart/change.js calls to avoid race conditions.
   */
  async _removeWithChildren(line, parentKey, parentProductId, isBundleMember) {
    console.log('[Whoop] CartDrawer._removeWithChildren()', { line, parentKey, parentProductId, isBundleMember });
    // Show loading state on parent
    const parentEl = this.container.querySelector(`#CartDrawerItem-${line}`);
    if (parentEl) parentEl.classList.add('thb-loading');

    try {
      // Fetch cart to find children
      const cartResp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!cartResp.ok) {
        // Fallback to simple removal
        this.updateQuantity(line, '0');
        return;
      }
      const cart = await cartResp.json();
      const pid = String(parentProductId);

      // Find the removed item to check for bundle group
      var removedItem = null;
      for (let i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === parentKey) {
          removedItem = cart.items[i];
          break;
        }
      }

      var keysToRemove = [];
      var bundleGroupId = removedItem && removedItem.properties && removedItem.properties._bundle_group_id;

      if (bundleGroupId) {
        // Bundle-group-aware removal: remove ALL items with the same _bundle_group_id
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          const props = item.properties || {};
          if (props._bundle_group_id === bundleGroupId) {
            keysToRemove.push(item.key);
          }
        }
      } else {
        // Legacy fallback: collect keys of bonus and addon children linked to this parent
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          const props = item.properties || {};
          if (props._bonus === 'true') {
            if (props._bonus_parent_line === parentKey || props._bonus_of === pid) {
              keysToRemove.push(item.key);
            }
          }
          if (props._pdp_addon === 'true' && props._pdp_addon_of === pid) {
            keysToRemove.push(item.key);
          }
        }
        // Add the parent itself
        keysToRemove.push(parentKey);
      }

      // Show loading on child elements too
      this.container.querySelectorAll('.product-cart-item[data-bonus="true"], .product-cart-item[data-addon="true"]').forEach((el) => {
        el.classList.add('thb-loading');
      });

      // Remove all items sequentially to avoid race conditions
      for (let i = 0; i < keysToRemove.length; i++) {
        await fetch(`${theme.routes.cart_change_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: keysToRemove[i], quantity: 0 })
        }).catch(() => {});
      }

      // Refresh cart drawer with clean state
      dispatchCustomEvent('line-item:change:end', { quantity: 0 });
      // Only check for orphaned bundle items if the removed item was part of a bundle
      if (isBundleMember) {
        this._pendingOrphanCheck = true;
      }
      this.refresh();
    } catch (e) {
      // Fallback to simple removal
      this.updateQuantity(line, '0');
    }
  }

  async _removeBundleGroup(bundleGroupEl) {
    console.log('[Whoop] CartDrawer._removeBundleGroup()');
    // Show loading on all items in the bundle group
    bundleGroupEl.querySelectorAll('.product-cart-item').forEach(el => el.classList.add('thb-loading'));

    try {
      const cartResp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!cartResp.ok) return;
      const cart = await cartResp.json();

      // Collect keys of all bundle items: app-premium, product_with_app_premium, freegift
      const bundleKeys = [];
      const bundleEls = bundleGroupEl.querySelectorAll('.product-cart-item[data-pulsetto]');
      const bundleProductIds = new Set();
      bundleEls.forEach(el => {
        const pid = el.dataset.productId;
        if (pid) bundleProductIds.add(String(pid));
      });

      for (const item of cart.items) {
        if (bundleProductIds.has(String(item.product_id))) {
          bundleKeys.push(item.key);
        }
      }

      // Remove all bundle items sequentially
      for (const key of bundleKeys) {
        await fetch(theme.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).catch(() => {});
      }

      dispatchCustomEvent('line-item:change:end', { quantity: 0 });
      this.refresh();
    } catch (e) {
      console.error('[Whoop] _removeBundleGroup failed:', e);
      this.refresh();
    }
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    const el = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return el ? el.innerHTML : '';
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }

  /**
   * If any pulsetto bundle items exist without a complete bundle
   * (app + device), removes the orphaned remainder in a single
   * batch request then refreshes the cart drawer.
   */
  async _removeOrphanedBundleItems() {
    console.log('[Whoop] CartDrawer._removeOrphanedBundleItems()');
    // Only check LEGACY bundle items (no data-bundle-group-id). Stepped bundles
    // have their own integrity check in bonus-items.js.
    const allBundleItems = this.container.querySelectorAll('.product-cart-item[data-pulsetto]:not([data-bundle-group-id])');
    if (allBundleItems.length === 0) {
      return;
    }

    const hasApp = this.container.querySelectorAll('.product-cart-item[data-pulsetto="app"]:not([data-bundle-group-id])').length > 0;
    const hasDevice = this.container.querySelectorAll('.product-cart-item[data-pulsetto="device"]:not([data-bundle-group-id])').length > 0;

    // Bundle is complete — nothing to clean up
    if (hasApp && hasDevice) {
      return;
    }

    // Only clean up if at least one bundle part exists (orphaned).
    // If neither app nor device is present, there's no bundle to clean up.
    if (!hasApp && !hasDevice) {
      return;
    }

    allBundleItems.forEach((item) => item.classList.add('thb-loading'));

    const orphanProductIds = new Set();
    allBundleItems.forEach((item) => {
      const pid = item.dataset.productId;
      if (pid) orphanProductIds.add(String(pid));
    });

    try {
      const cartResp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!cartResp.ok) { this.refresh(); return; }
      const cart = await cartResp.json();

      const keysToRemove = [];
      cart.items.forEach((item) => {
        if (orphanProductIds.has(String(item.product_id))) {
          keysToRemove.push(item.key);
        }
      });

      // Sequential removals — Shopify cart API is not safe for parallel mutations
      for (const key of keysToRemove) {
        await fetch(`${theme.routes.cart_change_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).catch(() => {});
      }
    } catch (e) {
      console.error('[Whoop] _removeOrphanedBundleItems error:', e);
    }

    this.refresh();
  }
  
  updateQuantity(line, quantity) {
    console.log('[Whoop] CartDrawer.updateQuantity()', { line, quantity });
    const lineEl = this.container.querySelector(`#CartDrawerItem-${line}`);
    if (lineEl) lineEl.classList.add('thb-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));
        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
        const updatedEl = this.container.querySelector(`#CartDrawerItem-${line}`);
        if (updatedEl) updatedEl.classList.remove('thb-loading');
        handleAltProductPrices();
        const wasSyncing = this._syncingApp;
        this._syncingApp = false;
        if (!wasSyncing) {
          this.syncAppDeviceGiftQuantity();
        }
        if (this._pendingOrphanCheck) {
          this._pendingOrphanCheck = false;
          console.log('[Whoop] Running deferred _removeOrphanedBundleItems after updateQuantity');
          this._removeOrphanedBundleItems();
        }
      })
      .catch((e) => {
        console.error('[Whoop] CartDrawer.updateQuantity error:', e);
        if (lineEl) lineEl.classList.remove('thb-loading');
        dispatchCustomEvent('line-item:change:end', { quantity: quantity });
      });
  }
  refresh() {
    console.log('[Whoop] CartDrawer.refresh()');
    const sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        if (!response.ok) throw new Error(`Refresh failed: ${response.status}`);
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this._syncingApp = false;
        this.syncAppDeviceGiftQuantity();
        if (window.bonusItemsManager) window.bonusItemsManager.syncBonusQuantities();
        if (this._pendingOrphanCheck) {
          this._pendingOrphanCheck = false;
          console.log('[Whoop] Running deferred _removeOrphanedBundleItems after refresh');
          this._removeOrphanedBundleItems();
        }
      })
      .catch((e) => {
        console.error('[Whoop] CartDrawer.refresh error:', e);
      });
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    tempSelect.style.cssText = "visibility:hidden;position:fixed;pointer-events:none";
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    // Read in one frame, write in next to avoid forced reflow
    requestAnimationFrame(() => {
      const width = tempSelect.clientWidth;
      tempSelect.remove();
      requestAnimationFrame(() => {
        if (width > 0) {
          sel.style.width = `${width + 12}px`;
        }
      });
    });
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
      button.addEventListener("click", (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute('aria-expanded', (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString());
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      this.isClosing = true;

      // Batch reads
      const startHeight = this.details.offsetHeight;
      const endHeight = this.summary.offsetHeight;

      if (this.animation) {
        this.animation.cancel();
      }

      // Write: animate
      this.animation = this.details.animate({
        height: [`${startHeight}px`, `${endHeight}px`]
      }, {
        duration: 250,
        easing: 'ease'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Read then write
      const currentHeight = this.details.offsetHeight;
      this.details.style.height = `${currentHeight}px`;
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;

      // Batch reads
      const startHeight = this.details.offsetHeight;
      const endHeight = this.summary.offsetHeight + this.content.offsetHeight;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');

      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');

      setTimeout(() => {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');

          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {

  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }

}
/**
 *  @class
 *  @function AnchorLinkScroll
 */
class AnchorLinkScroll {
  constructor() {
    this.init();
  }

  getScrollOffset() {
    return window.innerWidth >= 768 ? 120 : 105;
  }

  getTargetElement(anchorId) {
    return document.querySelector(`[data-anchor-id="${anchorId}"]`);
  }

  scrollToElement(element) {
    if (!element) return;

    const offset = this.getScrollOffset();
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  init() {
    // Handle initial page load with hash
    if (window.location.hash) {
      const anchorId = window.location.hash.substring(1);
      const targetElement = this.getTargetElement(anchorId);

      if (targetElement) {
        // Delay to ensure page is fully loaded
        setTimeout(() => {
          this.scrollToElement(targetElement);
        }, 100);
      }
    }

    // Handle clicks on anchor links
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href*="#"]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      // Extract anchor ID from href
      let anchorId;
      if (href.startsWith('#')) {
        anchorId = href.substring(1);
      } else if (href.includes('#')) {
        const url = new URL(href, window.location.origin);
        // Only handle same-page anchors
        if (url.pathname !== window.location.pathname) return;
        anchorId = url.hash.substring(1);
      }

      if (!anchorId) return;

      const targetElement = this.getTargetElement(anchorId);
      if (targetElement) {
        e.preventDefault();
        this.scrollToElement(targetElement);
        // Update URL hash without jumping
        history.pushState(null, null, `#${anchorId}`);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {

  if (typeof CartDrawer !== 'undefined') {
    window.cartDrawer = new CartDrawer();
  }
  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
  if (typeof AnchorLinkScroll !== 'undefined') {
    new AnchorLinkScroll();
  }
});

function handleAltProductPrices() {
    const productCards = document.querySelectorAll('.product-card-small--add-to-cart');

    productCards.forEach((productCard) => {
        const productId = productCard.getAttribute('data-product-id');
        const altPricePresent = productCard.getAttribute('data-alt-price-present') === 'true';

        if (!altPricePresent) {
            return;
        }

        let totalQuantity = 0;
        document.querySelectorAll(`.product-cart-item[data-product-id="${productId}"], tr[data-cart-product-id="${productId}"] .qty`).forEach(item => {
            const quantityInput = item.closest('.product-cart-item, tr').querySelector('.qty');
            if (quantityInput) {
                totalQuantity += parseInt(quantityInput.value, 10);
            }
        });

        document.querySelectorAll(`.product-card-small--add-to-cart[data-product-id="${productId}"]`).forEach(card => {
            const originalPriceElement = card.querySelector('.original_price');
            const customMetafieldPriceElement = card.querySelector('.custom_metafield_price');

            //if (totalQuantity % 2 === 0) { 
              //  originalPriceElement.classList.remove('hide');
             //   customMetafieldPriceElement.classList.add('hide');
          //  } else { 
              //  originalPriceElement.classList.add('hide');
              //  customMetafieldPriceElement.classList.remove('hide');
           // }
        });
    });
}
